import React from "react";
import { Button, Card, CardBody, CardHeader, CardTitle, Input } from "reactstrap";
import Select from "react-select";
import { reactSelectPortalProps } from "utils/reactSelectStyles";
import { formatCurrency } from "../../../../utils/formatCurrency";

const Step2VeiculosSimulacao = ({
  formData,
  veiculos,
  vehicleTypes,
  simulating,
  onAddVeiculo,
  onRemoveVeiculo,
  onVeiculoChange,
  onSimular,
  servicos = [],
  tiposServico = [],
  onAddServico,
  onRemoveServico,
  onServicoChange,
  simulouSemPropostas = false,
  onSolicitarTransportadora,
  onCalcularAproximado,
  aproximadoLoading = false,
  aproximadoResultado = null,
  // PO1-3303 (H1): cotação por caixas é envio fracionado (decisão 1A): um
  // veículo só, sem quantidade; o peso de referência é o total das caixas.
  porCaixas = false,
  pesoReferencia = null,
}) => {
  const destinoResumo = formData.cidade && formData.uf
    ? `${formData.cidade}/${formData.uf}`
    : formData.cep
      ? `CEP ${formData.cep}`
      : "destino pendente";

  return (
    <>
      <div className="info-note">
        Dados fixos do embarque: <strong>{destinoResumo}</strong> · NF{" "}
        <strong>{formData.numeroNota || "—"}</strong> · Valor{" "}
        <strong>{formData.valorNF}</strong>. Seguro aplicado apenas no 1º item.
      </div>
      {porCaixas && (
        <div className="info-note caixas-nota">
          Envio fracionado por volumes: a cotação é de um envio só
          {pesoReferencia != null ? <> ({pesoReferencia} kg no total)</> : null}. O mix de
          veículos vale para carga total.
        </div>
      )}

      <Card className="wizard-card">
        <CardHeader style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <CardTitle tag="h6">{porCaixas ? "Veículo" : "Mix de Veículos"}</CardTitle>
          {!porCaixas && (
            <Button color="primary" size="sm" outline onClick={onAddVeiculo}>
              + Adicionar veículo
            </Button>
          )}
        </CardHeader>
        <CardBody style={{ padding: "0 0 8px 0", overflowX: "auto" }}>
          <table className="vehicles-table">
            <thead>
              <tr>
                <th style={{ width: 40 }}>#</th>
                <th>Tipo de Veículo</th>
                <th style={{ width: 90 }}>Qtd</th>
                <th style={{ width: 110 }}>Peso (kg)</th>
                <th style={{ width: 130 }}>Frete Simulado</th>
                <th style={{ width: 40 }}></th>
              </tr>
            </thead>
            <tbody>
              {veiculos.map((v, i) => (
                <tr key={v.id}>
                  <td>
                    <span className="vehicle-index-badge">{i + 1}</span>
                  </td>
                  <td>
                    <Select
                      className="wizard-select"
                      classNamePrefix="wizard-select"
                      options={vehicleTypes}
                      value={v.tipoVeiculo}
                      onChange={(opt) => onVeiculoChange(v.id, "tipoVeiculo", opt)}
                      placeholder="Selecione..."
                      isClearable
                      {...reactSelectPortalProps()}
                      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                    />
                    {/* PO1-3480: veículo do catálogo sem tabela do embarcador */}
                    {v.tipoVeiculo && v.tipoVeiculo.semTabela ? (
                      <div className="veiculo-sem-tabela" style={{ fontSize: 11, marginTop: 4, color: "var(--everlog-status-warning, #ff8d72)" }}>
                        Sem tabela de frete: não tem frete simulado. Siga por Frete Spot ou Leilão.
                      </div>
                    ) : null}
                  </td>
                  <td>
                    {porCaixas ? (
                      <span className="caixas-qtd-fixa">1</span>
                    ) : (
                    <Input
                      type="text"
                      inputMode="numeric"
                      className="wizard-input"
                      value={v.quantidade}
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, "");
                        onVeiculoChange(v.id, "quantidade", val);
                      }}
                      onBlur={() => {
                        if (!v.quantidade) {
                          onVeiculoChange(v.id, "quantidade", "1");
                        }
                      }}
                    />
                    )}
                  </td>
                  <td>
                    <Input
                      type="text"
                      inputMode="decimal"
                      className="wizard-input"
                      value={v.peso}
                      placeholder={
                        i === 0
                          ? pesoReferencia != null
                            ? String(pesoReferencia)
                            : formData.peso
                          : ""
                      }
                      onChange={(e) => onVeiculoChange(v.id, "peso", e.target.value)}
                    />
                  </td>
                  <td>
                    {v.freteSimulado != null ? (
                      <span className="frete-simulado-value">{formatCurrency(v.freteSimulado)}</span>
                    ) : (
                      <span className="frete-pending">—</span>
                    )}
                  </td>
                  <td>
                    {i > 0 && !porCaixas && (
                      <button
                        onClick={() => onRemoveVeiculo(v.id)}
                        style={{
                          background: "none",
                          border: "none",
                          color: "#e74c3c",
                          cursor: "pointer",
                          fontSize: 16,
                          padding: "0 4px",
                        }}
                        title="Remover"
                      >
                        ×
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardBody>
      </Card>

      {/* PO1-2769 — serviços adicionais somados ao frete total */}
      <Card className="wizard-card">
        <CardHeader style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <CardTitle tag="h6">Serviços</CardTitle>
          <Button color="primary" size="sm" outline onClick={onAddServico}>
            + Adicionar serviço
          </Button>
        </CardHeader>
        <CardBody style={{ padding: "0 0 8px 0", overflowX: "auto" }}>
          {servicos.length === 0 ? (
            <p style={{ fontSize: 12, color: "var(--everlog-card-muted)", padding: "10px 14px", margin: 0 }}>
              Nenhum serviço adicional. Os valores informados aqui somam ao frete total.
            </p>
          ) : (
            <table className="vehicles-table">
              <thead>
                <tr>
                  <th style={{ width: 40 }}>#</th>
                  <th>Tipo de Serviço</th>
                  <th style={{ width: 150 }}>Valor (R$)</th>
                  <th style={{ width: 40 }}></th>
                </tr>
              </thead>
              <tbody>
                {servicos.map((s, i) => (
                  <tr key={i}>
                    <td>
                      <span className="vehicle-index-badge">{i + 1}</span>
                    </td>
                    <td>
                      <Select
                        className="wizard-select"
                        classNamePrefix="wizard-select"
                        options={tiposServico}
                        value={
                          s.idTipoServico != null
                            ? { value: s.idTipoServico, label: s.tipoServico }
                            : null
                        }
                        onChange={(opt) =>
                          onServicoChange(i, {
                            idTipoServico: opt ? opt.value : null,
                            tipoServico: opt ? opt.label : "",
                          })
                        }
                        placeholder="Selecione..."
                        isClearable
                        {...reactSelectPortalProps()}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                      />
                    </td>
                    <td>
                      <Input
                        type="text"
                        inputMode="decimal"
                        className="wizard-input"
                        value={s.valor}
                        placeholder="0,00"
                        onChange={(e) => onServicoChange(i, { valor: e.target.value })}
                      />
                    </td>
                    <td>
                      <button
                        onClick={() => onRemoveServico(i)}
                        style={{
                          background: "none",
                          border: "none",
                          color: "#e74c3c",
                          cursor: "pointer",
                          fontSize: 16,
                          padding: "0 4px",
                        }}
                        title="Remover"
                      >
                        ×
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </CardBody>
      </Card>

      <div className="simulate-btn-area">
        <Button
          color="primary"
          size="lg"
          onClick={onSimular}
          disabled={simulating}
          style={{ minWidth: 180 }}
        >
          {simulating ? (
            <>
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                style={{ marginRight: 8 }}
              />
              Simulando...
            </>
          ) : (
            "Simular Fretes"
          )}
        </Button>
      </div>

      {simulouSemPropostas && (
        <div
          className="sem-propostas-callout"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            gap: 12,
          }}
        >
          {/* Topo: explicação */}
          <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
            <div className="sem-propostas-icone" aria-hidden>!</div>
            <div className="sem-propostas-texto">
              <strong>
                Nenhuma transportadora retornou cotação para essa rota.
              </strong>
              <p>
                Pode ser que a rota não esteja cadastrada nas tabelas vigentes.
                Solicite a cotação manualmente, calcule um frete aproximado
                (estimativa) ou avance e inclua um "+ Frete Spot" com o valor
                negociado com a transportadora.
              </p>
            </div>
          </div>

          {/* Meio: resultado do frete aproximado */}
          {aproximadoResultado &&
            (() => {
              const itens = Array.isArray(aproximadoResultado)
                ? aproximadoResultado
                : [aproximadoResultado];
              const temAlgum = itens.some(
                (r) =>
                  r &&
                  Array.isArray(r.transportadoras) &&
                  r.transportadoras.length > 0
              );
              if (!temAlgum) {
                return (
                  <div
                    className="sem-propostas-texto"
                    style={{
                      borderTop: "1px solid var(--everlog-card-border)",
                      paddingTop: 10,
                    }}
                  >
                    <strong>
                      Sem base suficiente para estimar este trecho.
                    </strong>
                    <p>
                      A(s) transportadora(s) não têm cidades cadastradas
                      suficientes nesse estado/região. Solicite a cotação à
                      transportadora.
                    </p>
                  </div>
                );
              }
              return (
                <div
                  className="aproximado-resultado"
                  style={{
                    border: "1px solid var(--everlog-card-border)",
                    borderRadius: 6,
                    padding: "12px 14px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: 700,
                      fontSize: 13,
                      marginBottom: 8,
                      color: "var(--everlog-card-title)",
                    }}
                  >
                    Frete aproximado — estimativa, sujeito a confirmação
                  </div>
                  {itens.map((r, idx) => (
                    <div key={r.numero || idx} style={{ marginBottom: 10 }}>
                      {(r.transportadoras || []).map((t) => (
                        <div
                          key={t.transportadora}
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "baseline",
                            gap: 8,
                            padding: "4px 0",
                          }}
                        >
                          <span style={{ fontWeight: 600 }}>
                            {t.transportadora}
                          </span>
                          <span
                            style={{
                              fontWeight: 700,
                              color: "var(--theme-accent)",
                            }}
                          >
                            {formatCurrency(t.aproximado)}
                          </span>
                          <span
                            style={{
                              fontSize: 11,
                              color: "var(--everlog-card-muted)",
                            }}
                          >
                            faixa {formatCurrency(t.min)}–
                            {formatCurrency(t.max)} · {t.nCidades} cidades ·
                            base{" "}
                            {t.viaRegiao
                              ? `região ${r.regiao || ""}`.trim()
                              : `UF ${r.ufDestino}`}
                          </span>
                        </div>
                      ))}
                      {r.margemPctAplicada > 0 && (
                        <div
                          style={{
                            fontSize: 11,
                            color: "var(--everlog-card-muted)",
                            marginTop: 2,
                          }}
                        >
                          Inclui margem de segurança de {r.margemPctAplicada}%.
                        </div>
                      )}
                    </div>
                  ))}
                  <div
                    style={{
                      fontSize: 11,
                      color: "var(--everlog-card-muted)",
                      borderTop: "1px solid var(--everlog-card-border)",
                      paddingTop: 6,
                    }}
                  >
                    Mediana de cotações reais às cidades que a transportadora
                    atende no estado/região — não é cotação fechada.
                  </div>
                </div>
              );
            })()}

          {/* Base: ações */}
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <Button
              onClick={onSolicitarTransportadora}
              disabled={!onSolicitarTransportadora}
              style={{
                background: "var(--everlog-info-button-bg)",
                border: "1px solid var(--everlog-info-button-border)",
                color: "var(--everlog-info-button-text)",
                fontWeight: 600,
              }}
            >
              Solicitar à Transportadora
            </Button>
            <Button
              onClick={onCalcularAproximado}
              disabled={!onCalcularAproximado || aproximadoLoading}
              style={{
                background: "var(--everlog-info-button-bg)",
                border: "1px solid var(--everlog-info-button-border)",
                color: "var(--everlog-info-button-text)",
                fontWeight: 600,
                opacity: !onCalcularAproximado || aproximadoLoading ? 0.6 : 1,
              }}
            >
              {aproximadoLoading ? "Calculando..." : "Calcular frete aproximado"}
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default Step2VeiculosSimulacao;
